import { EN_ALPHABET_AND_NUMBERS } from '@monoimin/constants';

export const generateId = (length: number) => {
  let result = '';

  const charactersLength = EN_ALPHABET_AND_NUMBERS.length;

  for (let i = 0; i < length; i++) {
    result += EN_ALPHABET_AND_NUMBERS.charAt(
      Math.floor(Math.random() * charactersLength)
    );
  }

  return result;
};

export default generateId;
